<script setup lang="ts">
interface Props {
  id?: string
  src: string
}
defineProps<Props>()
</script>

<template>
  <CardComponent bg="light">
    <ImageComponent
      :id
      :src
      class="aspect-[17/9] rounded-md object-cover"
    />
  </CardComponent>
</template>
